var _path, _path2, _path3, _path4, _path5, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHugLinkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 45,
    viewBox: "0 0 149 45",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_510_126)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4138 24.4078C30.4138 22.8891 31.7064 21.6611 33.2575 21.6611C34.8085 21.6611 36.1011 22.8891 36.1011 24.4078V30.3536H44.5027V24.4078C44.5027 22.8891 45.7953 21.6611 47.3464 21.6611C48.8974 21.6611 50.19 22.8891 50.19 24.4078V41.5342C50.19 43.053 48.8651 44.2809 47.3464 44.2809C45.8276 44.2809 44.5027 43.053 44.5027 41.5342V35.3946H36.1011V41.5342C36.1011 43.053 34.7762 44.2809 33.2575 44.2809C31.7387 44.2809 30.4138 43.053 30.4138 41.5342V24.4078Z",
    fill: "#2C3E50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5391 37.8181C66.0885 37.1072 66.347 36.1055 66.347 34.6837V24.4078C66.347 22.8891 67.6072 21.6611 69.1906 21.6611C70.774 21.6611 72.0342 22.8891 72.0342 24.4078V35.2653C72.0342 37.6888 71.3557 39.7246 70.0954 41.2434C68.4151 43.1822 65.7653 44.2809 62.3401 44.2809C58.9148 44.2809 56.2974 43.1822 54.617 41.2434C53.3568 39.7246 52.6782 37.6888 52.6782 35.2653V24.4078C52.6782 22.8891 53.9708 21.6611 55.5218 21.6611C57.0729 21.6611 58.3654 22.8891 58.3654 24.4078V34.6837C58.3654 36.1055 58.624 37.1072 59.1733 37.8181C59.9488 38.8198 61.0152 39.143 62.3077 39.143C63.6972 39.143 64.7636 38.8198 65.5391 37.8181Z",
    fill: "#2C3E50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2283 31.5815C93.941 31.5815 94.7811 32.7448 94.7811 34.3282V41.5342C94.7811 43.053 93.7148 44.2809 92.0021 44.2809C90.9681 44.2809 90.1925 43.8931 89.7401 43.2792C88.6415 43.7639 87.0581 44.2809 85.0546 44.2809C78.4303 44.2809 73.6478 40.3386 73.6478 32.9387C73.6478 26.4436 78.9796 21.6611 85.604 21.6611C87.5751 21.6611 88.9323 21.8873 90.3864 22.3397C91.5497 22.6952 92.4868 23.5677 92.4868 24.8925C92.4868 26.4436 91.2912 27.5423 89.8371 27.5423C89.0939 27.5423 88.5122 27.2838 87.6397 27.0576C87.0581 26.896 86.3472 26.799 85.4424 26.799C82.1464 26.799 79.5613 29.4165 79.5613 32.9387C79.5613 36.4609 81.8232 39.2076 85.4424 39.2076C87.0581 39.2076 88.286 38.8522 89.1908 38.4644V36.6225H87.3812C86.0564 36.6225 84.9577 35.4915 84.9577 34.102C84.9577 32.7125 86.0564 31.5815 87.3812 31.5815H92.2283Z",
    fill: "#2C3E50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2926 23.1307C98.2926 22.4521 98.8419 21.8705 99.5851 21.8705C100.328 21.8705 100.878 22.4521 100.878 23.1307V41.8728H111.412C112.026 41.8728 112.511 42.3898 112.511 43.0361C112.511 43.6824 112.026 44.1671 111.412 44.1671H99.5851C98.8419 44.1671 98.2926 43.5855 98.2926 42.9069V23.1307ZM113.545 22.6137C113.545 21.8382 114.191 21.1919 114.967 21.1919C115.742 21.1919 116.388 21.8382 116.388 22.6137C116.388 23.3892 115.742 24.0355 114.967 24.0355C114.191 24.0355 113.545 23.3892 113.545 22.6137ZM114.999 29.3027C115.645 29.3027 116.194 29.7874 116.194 30.4337V43.3593C116.194 43.9732 115.645 44.4902 114.999 44.4902C114.353 44.4902 113.803 43.9732 113.803 43.3593V30.4337C113.803 29.7874 114.353 29.3027 114.999 29.3027ZM119.232 30.466C119.232 29.8197 119.781 29.3027 120.428 29.3027C121.074 29.3027 121.623 29.8197 121.623 30.466V32.0494C122.625 30.1429 124.564 29.3027 126.729 29.3027C128.474 29.3027 129.928 29.7228 130.962 30.6276C132.093 31.6293 132.707 33.245 132.707 35.507V43.3593C132.707 43.9732 132.158 44.4902 131.511 44.4902C130.865 44.4902 130.348 43.9732 130.348 43.3593V36.024C130.348 34.4083 130.025 33.1157 129.152 32.3079C128.506 31.6939 127.601 31.3708 126.276 31.3708C124.596 31.3708 123.271 32.114 122.463 33.6004C121.849 34.7638 121.623 36.1533 121.623 37.4458V43.3593C121.623 43.9732 121.074 44.4902 120.428 44.4902C119.781 44.4902 119.232 43.9732 119.232 43.3593V30.466ZM146.893 31.3708L141.981 36.0886C143.694 36.3794 145.083 37.058 146.085 38.0275C147.507 39.3846 148.185 41.2589 148.185 43.1007C148.185 44.1025 147.636 44.4902 146.99 44.4902C146.117 44.4902 145.923 43.9086 145.891 43.5208C145.794 41.8728 145.212 40.3217 144.049 39.2554C143.08 38.3829 141.755 37.8336 140.107 37.7366L137.877 39.934V43.3593C137.877 43.9732 137.328 44.4902 136.682 44.4902C136.035 44.4902 135.486 43.9732 135.486 43.3593V23.0661C135.486 22.4198 136.035 21.9028 136.682 21.9028C137.328 21.9028 137.877 22.4198 137.877 23.0661V37.155L145.115 29.9813C145.536 29.5935 145.859 29.2704 146.311 29.2704C146.893 29.2704 147.442 29.6258 147.442 30.3044C147.442 30.7245 147.248 31.0476 146.893 31.3708Z",
    fill: "#90C040"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_510_126",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7448 0C30.6552 0 28.9554 1.67817 28.9554 3.7398V11.6309C27.0252 21.2518 13.0656 21.5297 11.4779 21.5297C5.14869 21.5297 0 26.6784 0 33.0098C0 39.3411 5.14869 44.4898 11.4758 44.4898C17.8028 44.4898 22.902 39.3411 22.902 33.0098C22.902 28.0291 22.902 17.6779 32.8051 15.4762H40.6359C42.7255 15.4762 44.4252 13.7765 44.4252 11.6869V3.7398C44.4252 1.67817 42.7255 0 40.6359 0H32.7448Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_510_126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2138 -22.2151L-22.2435 22.2422L22.2138 66.6995L66.6711 22.2422L22.2138 -22.2151Z",
    fill: "url(#paint0_linear_510_126)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_510_126",
    x1: 4.3131,
    y1: 41.9659,
    x2: 45.4923,
    y2: 0.7867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07B1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#0BB1AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1AB39F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#31B58C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#52B971"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#7CBD50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#90C040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FBBF09"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#F6A40F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#F18B15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#EE7919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#EC6F1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EC6C1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_510_126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148.185,
    height: 44.4898,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHugLinkIcon);
export default __webpack_public_path__ + "static/media/hug-link-icon.fc8ebfae7b31c4d47d3ef036f74d17a9.svg";
export { ForwardRef as ReactComponent };